import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { map, Observable } from 'rxjs';
import { HTTPCONSTANTS } from '../http/http-constants';
import type { INotificationData } from '../models/notification-data';

@Injectable({ providedIn: 'root' })
export class NotificationHttpService {

  constructor(
    private http: HttpClient,
    @Inject('getAccessToken') private getAccessToken: () => string,
  ) {}

  getNotifications(): Observable<INotificationData[]> {
    const url = `${HTTPCONSTANTS.protocol}${HTTPCONSTANTS.baseAddress}/notifications/notifications`;
    return this.http.get<{ notifications: INotificationData[] }>(url).pipe(
      map(response => response.notifications)
    );
  }
}